module.exports = __webpack_public_path__ + "img/icon4.b5b0f034.png";